import React from 'react';

import { ButtonGroup } from '../material-ui/ButtonGroup';
import { Grid } from '../material-ui/Grid';
import { ManualEditShortcut } from './ManualInputShortcut/ManualInputShortcut';
import { Shortcut } from './Shortcut/Shortcut';
import { useStyles } from './useStyles';

export const Shortcuts = ({ shortcuts, clickHandler, currentValue }) => {
    const classes = useStyles();

    return (
        <div className={classes.scrollContainer}>
            <Grid container={true} justifyContent="flex-start" alignItems="center" wrap="nowrap" className={classes.container}>
                <ButtonGroup variant="text" className={classes.shortcuts}>
                    <>
                        {(shortcuts || []).map((shortcut) => (
                            <Shortcut key={shortcut.value} shortcut={shortcut} clickHandler={clickHandler} currentValue={currentValue} />
                        ))}
                        <ManualEditShortcut
                            key="manual"
                            shortcut={{ label: '', value: 'manual' }}
                            clickHandler={clickHandler}
                            currentValue={currentValue}
                        />
                    </>
                </ButtonGroup>
            </Grid>
        </div>
    );
};
